import type { ActivityConfig } from '../../types/activity.js'

const algorithmDemoConfig: ActivityConfig = {
  id: 'algorithm-demo',
  name: 'Algorithm Demonstrations',
  description: 'Instructor-driven algorithm demonstrations with synchronized visualization',
  color: 'indigo',
  standaloneEntry: {
    enabled: true,
    supportsDirectPath: true,
    supportsPermalink: true,
    showOnHome: true,
    title: 'Algorithm Practice',
    description: 'Explore sorting, searching, and recursion algorithms independently',
  },
  deepLinkOptions: {
    algorithm: {
      label: 'Pre-select Algorithm',
      type: 'select',
      options: [
        { value: '', label: '(None - manual selection)' },
        { value: 'linear-search', label: 'Linear Search' },
        { value: 'guessing-game', label: 'Binary Search Game' },
        { value: 'binary-search', label: 'Binary Search' },
        { value: 'selection-sort', label: 'Selection Sort' },
        { value: 'insertion-sort', label: 'Insertion Sort' },
        { value: 'merge-sort', label: 'Merge Sort' },
        { value: 'factorial', label: 'Factorial (Recursion)' },
        { value: 'fibonacci', label: 'Fibonacci (Recursion)' },
      ],
    },
  },
  clientEntry: './client/index.tsx',
  serverEntry: './server/routes.ts',
}

export default algorithmDemoConfig
